<div *ngIf="isVisible.value" [style]="getContainerStyle()">
  @for (msg of this.messages; track msg.bannerAuto) {
    <div class="banner-msg__container banner-msg__container--{{ getMsgClass(msg) }}">
      <div class="banner-msg__close" *ngIf="msg.hideable">
        <button mat-raised-button (click)="closeMessage(msg)">
          <mat-icon><span>close</span></mat-icon>
        </button>
      </div>
      <div class="banner-msg__icon-container banner-msg__icon-container--{{ getMsgClass(msg) }}">
        <mat-icon class="banner-msg__icon-container--icon" *ngIf="msg.icon && msg.icon.length > 0"
          ><span>{{ msg.icon }}</span></mat-icon
        >
      </div>
      <div class="banner-msg__title" *ngIf="msg.title && msg.title.length > 0">
        <span [innerHtml]="msg.title"></span>
      </div>
      <div class="banner-msg__body">
        <span [innerHtml]="msg.body"></span>
      </div>
    </div>
  }
</div>
